import React from 'react';
import PageBase from "../../components/PageBase";

const Settings = props => {
	return (
		<PageBase title="Settings">
			<div style={{ padding: '20px' }}>
				<div style={{ 
					textAlign: 'center', 
					padding: '40px 20px',
					color: '#666'
				}}>
					<h3>Welcome to Settings</h3>
					<p>Use the menu on the left to navigate to different settings sections:</p>
					<ul style={{ 
						listStyle: 'none', 
						padding: 0, 
						marginTop: '20px',
						textAlign: 'left',
						maxWidth: '400px',
						margin: '20px auto'
					}}>
						<li style={{ padding: '8px 0' }}>• <strong>User Management:</strong> Manage user accounts and permissions</li>
						<li style={{ padding: '8px 0' }}>• <strong>License Management:</strong> View and manage license information</li>
						<li style={{ padding: '8px 0' }}>• <strong>Database Management:</strong> Manage database snapshots and backups</li>
						<li style={{ padding: '8px 0' }}>• <strong>Salesforce Managers:</strong> Manage Salesforce installation URL package</li>
					</ul>
				</div>
			</div>
		</PageBase>
	)
};

export default Settings;
